// extracted by css-extract-rspack-plugin
export default {"defaultLink":"SignInWithTwoFA_defaultLink__vTM4C","centeredLink":"SignInWithTwoFA_centeredLink__XfB7J","passwordText":"SignInWithTwoFA_passwordText__Ftql7"};